import WaybillsTableColumnForwarder from './index.vue'
export default WaybillsTableColumnForwarder